import { render } from "./ReceiptSubstraction.vue?vue&type=template&id=0f6d837c&scoped=true"
import script from "./ReceiptSubstraction.vue?vue&type=script&lang=js"
export * from "./ReceiptSubstraction.vue?vue&type=script&lang=js"

import "./ReceiptSubstraction.vue?vue&type=style&index=0&id=0f6d837c&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6d837c"]])

export default __exports__